import Cloud_1 from "./image.png";
import Cloud_2 from "./image_1.png";
import Cloud_3 from "./image_2.png";
import Plane from "./Object.png";
import PlaneSmall from "./Plane.svg";
import Logo from "./Logo.svg";
import Home from "./Home.svg";
import Wallet from "./Wallet.svg";
import Booking from "./Booking.svg";
import Business from "./Business.svg";
import Explore from "./World.svg";
import Support from "./Support.svg";
import Premium from "./Premium.png";
import PremiumArrow from "./PremiumArrow.svg";
import MenuCloud from "./Menu-cloud.png";
import ProfilePicture from "./Person.png";
import House from "./House.svg";
import DropDown from "./DropDown.svg";
import Hotel from "./Hotel.svg";
import Villa from "./Villa.svg";
import Taxi from "./Taxi.svg";
import LocationPointer from "./LocationPointer.svg";
import Class from "./Class.svg";
import Calendar from "./Calendar.svg";
import DropDownGray from "./DropDownGray.svg";
import Close from "./Close.svg";
import PlaneFlying from "./PlaneFlying.webp";
import loadingImage from "./icons8-spinner.gif";
import Food from "./Food.svg";
import PlaneSeat from "./PlaneSeat.svg";
import Wifi from "./Wifi.svg";
import ChargingBattery from "./icons8-charging-battery-30.png";
import CheckMark from "./Checkmark.svg";
import ArrowLeft from "./Arrow-Left.svg";
import ArrowRight from "./Arrow-right.svg";
import CreditCard from "./CreditCard.svg";
import EMICard from "./EMICard.svg";
import GiftCard from "./GiftCard.svg";
import GooglePlay from "./GooglePlay.svg";
import PayPal from "./Paypal.svg";
import WalletPay from "./WalletPay.svg";
import PriceArrows from "./PriceArrows.svg";
import ArrowWhiteRight from "./Arrow-right-white.svg";
import ArrowWhiteLeft from "./Arrow-left-white.svg";
import Star from "./Star.svg";
import StarBlue from "./Star-blue.svg";
import StarGray from "./Star-gray.svg";
import LocationPointerBlue from "./Location-pointer-blue.svg";
import SoapyHands from "./SoapyHands.svg";
import InfoIcon from "./Info.svg";
import PersonClipArt from "./person-clipart.png";
import CoupleClipArt from "./CoupleClipArt.svg";
import StandingManClipArt from "./PersonClipArt.svg";
import FamilyClipArt from "./Family-clipart-black-and-white.svg";
import SmilyFace from "./lol.svg";
import SadFace from "./sadface.svg";
import Clock from "./icons8-wall-clock-24.png";
import AC from "./AirConditioning.svg";
import PickUpLocation from "./PickUpLocation.svg";
import OpeningHours from "./OpeningHours.svg";
import Plus from "./Plus.svg";
import Edit from "./Edit.svg";
import LoginPageImage from "./Rectangle.png";
import InteractiveStar from "./Interactive-star.svg";
import Google from "./Google.svg";
import NewYork from "./pexels-praneeth-koduru-6320208.jpg";
import LogOut from "./icons8-logout-50.png";

export const Assets = {
  LogOut,
  NewYork,
  Google,
  InteractiveStar,
  LoginPageImage,
  Edit,
  Plus,
  OpeningHours,
  PickUpLocation,
  AC,
  Clock,
  SmilyFace,
  SadFace,
  CoupleClipArt,
  StandingManClipArt,
  FamilyClipArt,
  PersonClipArt,
  InfoIcon,
  SoapyHands,
  StarGray,
  LocationPointerBlue,
  StarBlue,
  Star,
  ArrowWhiteLeft,
  ArrowWhiteRight,
  PriceArrows,
  CreditCard,
  EMICard,
  GiftCard,
  GooglePlay,
  PayPal,
  WalletPay,
  ArrowLeft,
  ArrowRight,
  CheckMark,
  Food,
  PlaneSeat,
  Wifi,
  ChargingBattery,
  loadingImage,
  PlaneFlying,
  Close,
  DropDownGray,
  Calendar,
  Class,
  LocationPointer,
  Taxi,
  Villa,
  Hotel,
  PlaneSmall,
  DropDown,
  House,
  ProfilePicture,
  MenuCloud,
  PremiumArrow,
  Premium,
  Cloud_1,
  Cloud_2,
  Cloud_3,
  Plane,
  Logo,
  Booking,
  Business,
  Explore,
  Support,
  Home,
  Wallet,
};
